module.exports = __webpack_public_path__ + "img/i-zcy-bg3.b41fa69e.png";